ACC.headerbanner = (function () {
    function moveBreadcrumbsToHeader() {
        const headerWrapper = document.querySelector('.header');
        const breadcrumbs = document.querySelector('.c-breadcrumbs-container');
        const aemHeader = document.querySelector('.header header');

        if (!aemHeader) {
            console.warn('Header is missing');
            return;
        }

        if (headerWrapper && breadcrumbs) {
            aemHeader.insertAdjacentElement('beforeend', breadcrumbs);
        }
    }
    return {
        _autoload: ['headerBanner'],

        headerBanner() {
            const pearsonbanner = $('header .pearson-banner');
            // eslint-disable-next-line no-unused-vars
            const searchBox = $('header .search-box');
            const pBannerCont = pearsonbanner.find('>div');
            const logoLink = encodeURI(pBannerCont.find('>a').attr('href'));
            const parSys = $('header > div > .parsys');
            const header = $('body header:first');
            // eslint-disable-next-line no-unused-vars
            const signIn = header.find('.sign-in-menu');

            pBannerCont.find('>a').remove();
            pBannerCont.find('.pearson-banner-always-learning').remove();

            /* Set [role="banner"] on actual <header> element */
            pearsonbanner.find('>div[role="banner"]').removeAttr('role');
            header.attr('role', 'banner');

            $('body > main').attr('id', 'main-content');

            pBannerCont.removeClass('container');
            pBannerCont
                // eslint-disable-next-line max-len
                .prepend(`<div id="site-logo" title="Pearson logo"><a href="${logoLink}" aria-label="Pearson logo" title="Pearson logo"><em class="sr-only">Pearson</em></a></div>`);

            parSys.appendTo('header .header');

            // if there is no menu-browse child page lis component,
            // append the info-menu as the primary nav for mobile
            if ($('.menu-browse .child-page-list-level-1').length === 0) {
                // $('body > header').addClass('no-menu');

                const infoMenuUl = $('.info-menu ul');
                $('.menu-browse').append('<div class="menu-browse--no-subs"> </div>');

                infoMenuUl.clone().appendTo('.menu-browse--no-subs');

                const newInfo = $('.menu-browse--no-subs');
                newInfo.find('ul').addClass('child-page-list-level-1');
                newInfo.find('li').addClass('subnav-item');
            }

            // add skip the navigation hidden link and make it link to MAIN (#main-content)
            $('.skip-nav').prependTo(header);

            moveBreadcrumbsToHeader();
        },
    };
}());
